import AuthProfilePinScreen from '@/components/Auth/ProfilePin/AuthProfilePinScreen'
import { FC } from 'react'

const Page: FC = () => {
    return <AuthProfilePinScreen />
}

export default Page
